import { ConfirmingSimulationReportGenerator } from './ConfirmingSimulationReportGenerator';

export const generateConfirmingSimulationPDF = async (
  selectedRequest: any,
  userName: string,
  imageBase64: string,
  payouts?: any,
) => {
  const generator = new ConfirmingSimulationReportGenerator({
    userName,
    imageBase64,
    title: `Detalle ${selectedRequest.id ? `Solicitud ${selectedRequest.id}` : 'Simulación'}`,
    fileName: `${selectedRequest.id ? `Solicitud` : 'Simulación'}-Confirming${selectedRequest.id ? `-${selectedRequest.id}` : ` ${selectedRequest.stakeholderName}`}.pdf`,
    selectedRequest,
    showClientInfo: selectedRequest.showClientInfo,
    showRequestInfo: selectedRequest.showRequestInfo,
    showDates: selectedRequest.showDates,
    showAdvance: selectedRequest.showAdvance,
    showRate: selectedRequest.showRate,
    showArrearRate: selectedRequest.showArrearRate,
    showAmounts: selectedRequest.showAmounts,
    showDocuments: selectedRequest.showDocuments,
    showOperationCosts: selectedRequest.showOperationCosts,
    showExpenses: selectedRequest.showExpenses,
    showAccountReceivable: selectedRequest.showAccountReceivable,
    payouts,
  });
  await generator.generate();
};
